// GET ORDER BY ID
import axios from '../axios-config';

const getOrderByID = async (orderId, mage) => {
  let config = {
    method: 'GET',
    url: `/customer/orders-details/${orderId}`,
    headers: {
      ...(mage ? { mage: `Bearer ${mage}` } : {}),
    },
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const getOrderByIDV2 = async (orderId, mage) => {
  let config = {
    method: 'GET',
    url: `/customer/orders/${orderId}`,
    headers: {
      ...(mage ? { mage: `Bearer ${mage}` } : {}),
    },
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const successRating = async (values) => {
  const data = JSON.stringify({ ...values });
  const config = {
    method: 'post',

    url: '/customer/customer_survey_form',
    data,
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const getCheckoutCouponByID = async (handshake, orderId, mage) => {
  let config = {
    method: 'POST',
    url: `/customer/checkoutCoupon?orderId=${orderId}`,
    headers: {
      Authorization: `Bearer ${handshake}`,
      ...(mage ? { mage: `Bearer ${mage}` } : {}),
    },
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

export { getOrderByID, getCheckoutCouponByID, successRating, getOrderByIDV2 };
